export default __webpack_public_path__ + "static/media/01.f61a8e66.png";